import {Box} from "@mui/material";

export const DEFAULT_MIN_HEIGHT = "47em";

export interface DataGridContainerProps {
    height?: string;
    children?: React.ReactNode;
}

export default function DataGridContainer(props: Readonly<DataGridContainerProps>) {
    const {children} = props;
    const height = props.height ?? DEFAULT_MIN_HEIGHT;

    return (
            <Box sx={{height: height}}>
                {children}
            </Box>
    );
}